<template>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="tableData"
		:loading="loading"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
	   <template slot="id" slot-scope="props">
          <span>{{props.rowData.id}}</span>
        </template>
        <template slot="message" slot-scope="props">
          <span>{{props.rowData.message}}</span>
        </template>

		 <template slot="likes" slot-scope="props">
          <span>{{props.rowData.likes}}</span>
        </template>


		 <template slot="dislikes" slot-scope="props">
          <span>{{props.rowData.dislikes}}</span>
        </template>
		   
		   	<template slot="status" slot-scope="props">
          <span  v-if="props.rowData.status === 'approved'" class="status--success">Проверено</span>
		  <span v-if="props.rowData.status === 'deleted'" class="status--error">Удалено</span>
		  <span v-if="props.rowData.status === 'disapproved'" class="status--error">Скрыто</span>
		  <span v-if="props.rowData.status === 'pending'" class="status--warning">в ожидании</span>
        </template>

		<template slot="actions" slot-scope="props" >
			<div class="reviews-actions">
			  <va-button v-if="props.rowData.status !== 'approved'" color="info" small @click="reviewModification('approve',props.rowData)">Одобрить</va-button>
			  <va-button v-if="props.rowData.status !== 'disapproved'" color="danger" small @click="reviewModification('disapprove',props.rowData)">Скрыть</va-button>
			  <va-button color="danger" small @click="reviewModification('remove',props.rowData)">Удалить</va-button>
		    </div>		  
        </template>
      </va-data-table>
    </va-card>
</template>

<script>
import api from '@/api/axios'
export default {
  name:'Table',
  props:{
	  tableData:{
		  type:Array,
		  required:true
	  },
	  fields:{
		  type: Array,
		  required:true
	  },
	  loading:{
		  type:Boolean,
		  required:true
	  }
  },
  methods:{
	  async reviewModification(reviewAction,review){
		  const method = reviewAction === 'remove' ? 'delete' : 'post';
		  let param = null;			  
			param = reviewAction === 'approve' ? '/approve' : '/disapprove';
			   try {  
			  await api({
				method,
				url:  `admin/product-comments/${ reviewAction === 'remove' ? review.id :  review.id + param }`,
				})
				.then((res)=>{
					this.$emit('updateReviews')
				});
		  } catch (error) {
			  return error
		  }
		  
		 
	  },
  }
}
</script>
<style lang="scss" scoped>
.reviews-actions{
	display: flex;
	justify-content: flex-end;
}
.status {
	&--success{
		color:#42ba96;
		font-weight: bold;
	}
	&--error{
		color:#ff3333;
		font-weight: bold;
	}
	&--warning{
		color:#ffcc00;
		font-weight: bold;
	}
}
</style>